export default __webpack_public_path__ + "static/media/face.b722d5de.svg";